import { useNavigate } from "react-router-dom"
import { useRecoilValue } from "recoil"
import {
  isClientNotFoundState,
  isCompanyNotFoundState,
  isRecruitNotFoundState,
} from "recoils/isNotFoundState"

export const useOnBoardingSignIn = () => {
  const isClientNotFound = useRecoilValue(isClientNotFoundState)
  const isCompanyNotFound = useRecoilValue(isCompanyNotFoundState)
  const isRecruitNotFound = useRecoilValue(isRecruitNotFoundState)
  const navigate = useNavigate()

  return () => {
    if (isClientNotFound) {
      navigate("/profile/edit")
      return
    }
    if (isCompanyNotFound) {
      navigate("/company/edit")
      return
    }
    if (isRecruitNotFound) {
      navigate("/recruit/new")
      return
    }
    navigate("/")
    return
  }
}
